{
  "title": "Ray of Enfeeblement",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level necromancy",
  "level": 2,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "A black beam of enervating energy springs from your finger toward a creature within range. Make a ranged spell attack against the target. On a hit, the target deals only half damage with weapon attacks that use Strength until the spell ends.",
    "At the end of each of the target’s turns, it can make a Constitution saving throw against the spell. On a success, the spell ends."
  ],
  "spellLists": ["warlock", "wizard"]
}
